import { render } from "./ComponentArchive.vue?vue&type=template&id=3eda4888&scoped=true"
import script from "./ComponentArchive.vue?vue&type=script&lang=js"
export * from "./ComponentArchive.vue?vue&type=script&lang=js"

import "./ComponentArchive.vue?vue&type=style&index=0&id=3eda4888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eda4888"]])

export default __exports__